export default "__VITE_ASSET__CekCKQy3__"